import { render, staticRenderFns } from "./PDFUploader.vue?vue&type=template&id=14fb8b54&scoped=true&"
import script from "./PDFUploader.vue?vue&type=script&lang=js&"
export * from "./PDFUploader.vue?vue&type=script&lang=js&"
import style0 from "./PDFUploader.vue?vue&type=style&index=0&id=14fb8b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb8b54",
  null
  
)

export default component.exports